import { useContext, useEffect, useState } from 'react';
import { useOutletContext, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { PlaceOutletContextType } from "../home/PlacesHome";
import { FollowedLead, NotificationType } from 'shared/topchef.types';
import placesApi from 'shared/topchef-api-places';
import Loading from 'pages/shared/loading/Loading'
import { NotificationContext } from 'shared/NotificationContext'
import { useErrorBoundary } from 'react-error-boundary'
import FollowedLeadDetailsFeesRejected from './followed-lead-details-fees-rejected/FollowedLeadDetailsFeesRejected';
import FollowedLeadDetailsFeesAccepted from './followed-lead-details-fees-accepted/FollowedLeadDetailsFeesAccepted';

const FollowedLeadDetails = () => {

  const { t } = useTranslation();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [isReady, setReady] = useState<boolean>(false);
  const [currentLead, setCurrentLead] = useState<FollowedLead | null>(null);

  const { showBoundary } = useErrorBoundary();


  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadLead() {
      try {
        const lead: FollowedLead = await placesApi.loadFollowedLead(loggedInPlace!.id, leadId);
        setCurrentLead(lead);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadLeadDetails', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (isReady) {
      return;
    }

    loadLead();

  }, [currentLead, isReady, leadId, loggedInPlace, showBoundary, triggerNotification]); // eslint-disable-line react-hooks/exhaustive-deps


  if (!isReady) {
    return (
      <Loading />
    );
  }

  console.log("je suis dans le FollowedLeadDetails");

  if (loggedInPlace.acceptReward) {
    return <FollowedLeadDetailsFeesAccepted loggedInPlace={loggedInPlace} currentLead={currentLead!}/>
  } else {
    return <FollowedLeadDetailsFeesRejected loggedInPlace={loggedInPlace} currentLead={currentLead!}/>
  }

}


export default FollowedLeadDetails;
